<template lang="pug">
  div
    h1.title.is-3.has-text-info(style='margin-bottom: 5px;') Colegios
    .buttons(style='margin-bottom: 10px;' )
      button.button.is-info.is-light(@click="reloadData")
        span.icon.is-small(:class="{ 'is-loading': storing }")
          i.fas.fa-redo-alt
      button.button.is-primary.is-light(@click="addData")
        span.icon.is-small
          i.fas.fa-plus
    .columns.is-vcentered.is-multiline(v-if="registros.length")
      .column.is-full-mobile.is-one-third-tablet.is-one-quarter-desktop(v-for="elm in registros" :key="elm.id")
        .card
          .card-content
            .content
              p.title.is-5.has-text-centered {{ elm.nombre }}
              p.subtitle.is-7.has-text-centered {{ elm.id }}
              p(style="margin-top: 30px;") {{ elm.descripcion }}
          .card-footer
            a.card-footer-item.no_select.has-text-link(@click="setedition(elm)") Editar
            a.card-footer-item.no_select.has-text-danger(@click="setDelete(elm.id)") Eliminar
    .title.is-4(v-else) No hay registros.
    Modal(v-model="confirmModal")
      .modal-card
        article.message.is-danger
          .message-header
            p.is-3 Advertencia
          .message-body.has-text-centered ¿ Está seguro de eliminar el registro ?
          .buttons(style="margin-bottom: 10px; display: inline-block; position: relative; left: 50%; transform: translateX(-50%);")
            button.button.is-danger(@click="continueDelete(confirmModal)")
              span Confirmar
            button.button.is-info(@click="confirmModal = false")
              span Cancelar
    Modal(v-model="openModal")
      .modal-card
        header.modal-card-head
          p.modal-card-title {{ selectedId ? "Edición" : "Creación"}} de congregación
        section.modal-card-body
          .field
            label.label(for="elmName") Nombre del colegio
            .control
              input.input(id="elmName" type="text" placeholder="Ingresa el nombre" v-model="objetivo.nombre")
          .field
            label.label(for="congDescr") Descripción del colegio
            .control
              textarea.textarea(id="congDescr" placeholder="Descríbela" v-model="objetivo.descripcion")
        footer.modal-card-foot
          button.button.is-success(@click="saveData" :class="{ 'is-loading': storing }") Guardar
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "colegio-component",

  components: {
    Modal
  },

  data: () => ({
    openModal: false,
    confirmModal: false,
    selectedId: null,
    objetivo: {
      nombre: "",
      descripcion: ""
    }
  }),

  computed: {
    registros() {
      return this.$store.state.colegios_list;
    },
    storing() {
      return this.$store.state.colegios_load;
    }
  },

  methods: {
    reloadData() {
      return this.$store.dispatch("listColegio");
    },
    addData() {
      this.openModal = true;
    },
    setDelete(id) {
      this.confirmModal = id;
    },
    continueDelete(id) {
      this.confirmModal = false;
      return this.$store
        .dispatch("removeColegio", { id })
        .then(() =>
          this.$toastr("success", "El registro se ha eliminado correctamente.")
        );
    },
    setedition(element) {
      this.selectedId = element.id;
      this.objetivo.nombre = element.nombre;
      this.objetivo.descripcion = element.descripcion;
      this.openModal = true;
    },
    async saveData() {
      let action;
      if (!this.selectedId) {
        action = this.$store.dispatch("storeColegio", {
          data: this.objetivo
        });
      } else {
        action = this.$store.dispatch("updateColegio", {
          id: this.selectedId,
          data: this.objetivo
        });
      }
      try {
        await action;
        this.objetivo.nombre = "";
        this.objetivo.descripcion = "";
        this.$toastr(
          "success",
          this.selectedId
            ? "El registro se actualizó correctamente."
            : "El registro se creó correctamente."
        );
      } catch (error) {
        console.error(error);
        this.$toastr(
          "error",
          this.selectedId
            ? "El registro no se pudo actualizar."
            : "El registro no se pudo crear."
        );
      }
      this.selectedId = null;
      this.openModal = false;
    }
  }
};
</script>
